import React from "react";
import { makeStyles, TableCell } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  info: {
    width: "35%",
    fontWeight: "normal",
    padding: theme.spacing(3, 0, 3, 6),
    [theme.breakpoints.only("xs")]: {
      fontSize: 14,
      padding: theme.spacing(2, 4, 2, 4),
    },
  },
}));

type TableInfoItemProps = {
  children: React.ReactNode;
  className?: string;
};

export default function TableInfoItem({ children, className }: TableInfoItemProps) {
  const classes = useStyles();
  return <TableCell className={`${classes.info} ${className || ""}`}>{children}</TableCell>;
}
